import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-remove-machine-mode',
  templateUrl: './remove-machine-mode.component.html',
  styleUrls: ['./remove-machine-mode.component.scss'],
})
export class RemoveMachineModeComponent implements OnInit {
  @Input() props: {
    modeIds: string[];
    modeNames: string[];
    machineId: string;
    userId: string;
    hazardData: any[];
  };
  public roadmapList: any[] = [];
  public machineModeNames: string[] = [];
  public translatedMessage: string = '';

  constructor(
    private modalController: ModalController,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.roadmapList = this.props?.hazardData || [];
    this.machineModeNames = this.props?.modeNames || [];
    
    // Create the translated message with machine mode names
    this.createTranslatedMessage();
  }

  /**
   * Creates the translated message with machine mode names interpolated
   */
  private createTranslatedMessage(): void {
    const modeNamesString = this.machineModeNames.join(', ');
    
    this.translate.get('remove_machine_mode_msg', { machineModes: modeNamesString })
      .subscribe((translatedText: string) => {
        this.translatedMessage = translatedText;
      });
  }

  /**
   * Closes modal
   */
  public closeModal() {
    this.modalController.dismiss({
      'removed': false
    });
  }

  /**
   * Confirms removal
   */
  public confirmRemoval() {
    this.modalController.dismiss({
      'removed': true
    });
  }
}
